module.exports = __webpack_public_path__ + "img/movingBoxesCat.7cfafbfe.png";